var help = {
    fetchGlobalTips: function () {
        if (this.globalTips) {
            return Promise.resolve();
        }

        var getSystemId = function () {
            if (typeof configureCommonGlobals !== 'undefined' && configureCommonGlobals) {
                return configureCommonGlobals.systemId;
            } if (typeof stockGlobals !== 'undefined' && stockGlobals) {
                return stockGlobals.systemId;
            } if (typeof globalpageglobals !== 'undefined' && globalpageglobals && globalpageglobals.cstorefrontsettings) {
                return globalpageglobals.cstorefrontsettings.system.id;
            }
        };

        return new Promise(function (resolve, reject) {
            var systemId = getSystemId();
            if (!systemId) {
                resolve([]);
                return;
            }
            $.ajax({
                url: '/api/supplier-service/suppliers/' + systemId + '/tips',
                method: 'GET',
                accept: 'application/json',
                success: function (globalTips) {
                    help.globalTips = globalTips;
                    resolve();
                },
                error: function () {
                    console.error('Error fetching global tips');
                    reject();
                }
            });
        });
    },
    pos: function (helpLinkId) {
        var pos = $('#validationMessagesDiv').offset();
        pos.top = $('#' + helpLinkId).offset().top;
        return pos;
    },
    getGlobalTip: function (tipName) {
        if (!this.globalTips) {
            return '';
        }
        return this.globalTips.find(function (tip) {
            return tip.name === tipName;
        });
    },
    panelClosed: function () {
        $.disconnect(tipViewPanel, 'close', this, 'panelClosed');
        $(window).unbind('resize');
        dynamic.setClass(this.helpLinkId, 'quoteHelp');
        this.helpLinkId = null;
    },
    windowResized: function () {
        tipViewPanel.windowResized();
    },
    showPanel: function (helpLinkId, content) {
        var previousHelpLinkId = this.helpLinkId;
        if (tipViewPanel.showing) {
            tipViewPanel.close();
        }
        if (previousHelpLinkId === helpLinkId) {
            return;
        }

        $.connect(tipViewPanel, 'close', this, 'panelClosed');
        var tempThis = this;
        $(window).resize(function (e) {
            tempThis.windowResized(e);
        });
        tipViewPanel.open(this.pos(helpLinkId), content);
        this.helpLinkId = helpLinkId;
        dynamic.setClass(helpLinkId, 'quoteHelp on');
    },
    tip: function (object, fieldName, globalName) {
        this.fetchGlobalTips().then(function () {
            var content = help.getHtml(object, fieldName);
            if (content === '') {
                var globalTip = help.getGlobalTip(globalName);
                content = help.getHtml(globalTip, 'content');
            }
            help.showPanel(fieldName, content);
        });
    },
    getHtml: function (object, fieldName) {
        return fieldName in object ? strUnweb(object[fieldName]) : '';
    },
    opTip: function (index) {
        var helpLinkId = 'opTip' + index;

        var coperationsmgr = configureglobals.coperationsmgr;
        var operation = coperationsmgr.operations[index];

        if (operation) {
            var tipContent = this.getHtml(operation, 'tipContent');
            this.showPanel(helpLinkId, tipContent);
        }
    },
    lfOpTip: function (index) {
        return this.opTip(index);
    }
};
